import React, { useState, useEffect } from "react";
import { useSelector } from "react-redux";
import Hashtags from "react-highlight-hashtags";
import LazyLoad from "react-lazy-load";
import {
  DATE_FORMATS,
  LANGUAGE_CODES,
  SOCIAL_SOURCES,
  VERTICALS,
} from "../../../../constants/app-constant";
import { FEED_DETAILS } from "../../../../constants/route-constants";
import {
  formatDate,
  getUniqueValuesFromList,
  truncate,
} from "../../../../utility/common-methods";
import {
  FacebookIcon,
  InstagramIcon,
  LinkIcon,
  PlusIcon,
  TagClose,
  TwitterIcon,
  VideoPlayIcon,
  YoutubePlayIcon,
  PinterestIcon,
  TwitterWBIcon,
} from "../../../Icons/icons.component";
import ArticleTags from "../../News/ArticleTags";
import { TagsListModal } from "../../TagsAndFavourites/Tags/TagsListModal";
import { unifiedEnvConfig } from "../../../../constants/api-endpoint";
import { httpDelete } from "../../../../utility/requestHelper";

const FavouriteFeedItem = (props) => {
  const {
    attachments,
    channel_type,
    city,
    comment_count,
    country,
    created_at,
    dislike_count,
    etag,
    fav_count,
    favourites,
    from_username,
    id,
    isModal,
    is_recent_media,
    is_top_media,
    is_user_verified,
    is_visitor_feed,
    lang,
    latitude,
    like_count,
    longitude,
    media_link,
    media_type,
    message,
    name,
    page_details,
    page_id,
    permalink,
    reaction_count,
    share_count,
    tags,
    thumbnail_link,
    title,
    tonality,
    type,
    updated_at,
    user_followers_count,
    view_count,
    vertical,
    clientId,
  } = props;
  const { V_SOCIAL, V_BLOG, V_FORUM } = VERTICALS;
  const { FACEBOOK, INSTAGRAM, YOUTUBE, TWITTER, PINTEREST } = SOCIAL_SOURCES;
  const [tagsList, setTagsList] = useState(tags);
  const [showAddTagListModal, setShowAddTagListModal] = useState(false);

  const selectedClient =
    useSelector(
      (state) => state.clientReducer && state.clientReducer.selectedClient
    ) || {};

  const handleFeedClick = () => {
    localStorage.removeItem("articleIdList");
    let redirectParam;
    if (vertical == V_SOCIAL) {
      redirectParam = "sad";
    } else if (vertical == V_BLOG || vertical == V_FORUM) {
      redirectParam = "bafad";
    }
    window.open(
      `https://${window.location.host}${FEED_DETAILS}/${redirectParam}/${clientId}-${channel_type}/${id}`,
      "_blank"
    );
  };

  const showMediaAttachments = () => {
    return Array.isArray(attachments) && attachments.length
      ? attachments.map((src, index) => {
          if (!src) {
            return null;
          }
          const { media_link, media_type } = src;
          if (media_type === "image") {
            return (
              <div className="imgThumbWrap">
                <div className="imgThumb">
                  <img alt={""} key={src} src={media_link} />
                </div>
              </div>
            );
          }
          if (media_type === "video") {
            return (
              <div className="videoThumb">
                <VideoPlayIcon />
                <a href={permalink} target="_blank">
                  <img src={media_link} alt="NA" />
                </a>
              </div>
            );
          }
          return null;
        })
      : "";
  };
  const pageTitle =
    channel_type == YOUTUBE
      ? name
      : channel_type == TWITTER
      ? `@${from_username}`
      : channel_type == PINTEREST
      ? from_username
      : page_details && page_details.name;

  const gotoPermalink = () => {
    if (!permalink) return;
    window.open(permalink, "_blank");
  };

  const renderSocialFeed = () => {
    const { display_picture, name = "" } = page_details || {};
    return (
      <>
        <div className="headlineWrapper">
          <div className="feedInfoHeader">
            <div className="feedNamePic">
              {display_picture && (
                <img src={display_picture} className="feedPic" />
              )}
              {/* <span className="feedName" onClick={() => handleFeedClick()}>{title}</span> */}
              <span className="feedName">{name || pageTitle || ""}</span>
            </div>
            {(name || pageTitle || display_picture) && channel_type && (
              <span className="feedDivider"></span>
            )}
            <div className="feedChannelDate">
              {channel_type == INSTAGRAM && <InstagramIcon />}
              {channel_type == FACEBOOK && <FacebookIcon />}
              {channel_type == YOUTUBE && <YoutubePlayIcon />}
              {channel_type == TWITTER && <TwitterWBIcon />}
              {/* {channel_type == PINTEREST && <PinterestIcon />} */}
              <span className="newsDate"></span>
            </div>
          </div>
          <div className="rightContainer">
            <ul className="dropDownContainer">
              <li className="themeLi tlLink">
                <span onClick={gotoPermalink} className="linkIcon clickable">
                  <div className="hasTooltip">
                    <LinkIcon />
                    <span className="tooltipWrap left">Go to Page</span>
                  </div>
                </span>
              </li>
              <ArticleTags
                article={props}
                hideTheme
                callSocialAPI
                showFavouriteTag
                isSocial
                hideTonality
              />
            </ul>
          </div>
        </div>
        <div className="feedDetails" onClick={() => handleFeedClick()}>
          {channel_type == YOUTUBE ? (
            <Hashtags text={title || ""} />
          ) : (
            <Hashtags text={truncate(message)} />
          )}
        </div>
        <div className="imgContainer videoContainer">
          <LazyLoad offsetVertical="1000">
            <>
              {thumbnail_link && (
                <div className="videoThumb">
                  <VideoPlayIcon />
                  <a href={permalink} target="_blank">
                    <img src={thumbnail_link} alt="NA" />
                  </a>
                </div>
              )}
            </>
          </LazyLoad>
          {showMediaAttachments()}
        </div>
        <div className="metaTagsWrap" key={id + "1"}>
          {(channel_type == INSTAGRAM ||
            channel_type == FACEBOOK ||
            channel_type == YOUTUBE ||
            channel_type == TWITTER) && (
            <>
              <div className="mtWrap">
                <span className="label-span hoverable">Likes : </span>
                <span>{like_count}</span>
              </div>
              {channel_type == YOUTUBE && (
                <div className="mtWrap">
                  <span className="label-span">Dislikes :</span>{" "}
                  <span>{dislike_count}</span>
                </div>
              )}
            </>
          )}
          {channel_type == TWITTER && (
            <div className="mtWrap">
              <span className="label-span">Retweets :</span>{" "}
              <span>{share_count}</span>
            </div>
          )}
          <div className="mtWrap">
            <span className="label-span">Comments :</span>{" "}
            <span>{comment_count}</span>
          </div>
          {channel_type == FACEBOOK && (
            <div className="mtWrap">
              <span className="label-span">Share :</span>{" "}
              <span>{share_count}</span>
            </div>
          )}
          {channel_type == YOUTUBE && (
            <div className="mtWrap">
              <span className="label-span">Views :</span>{" "}
              <span>{view_count}</span>
            </div>
          )}
          <div className="mtWrap">
            <span className="label-span">Publish Date :</span>{" "}
            <span>
              {formatDate(new Date(created_at), DATE_FORMATS.DDMMYYYY_dash)}
            </span>
          </div>
          <div className="mtWrap mtAddTag">
            <span
              onClick={() => setShowAddTagListModal(true)}
              className="addTag"
            >
              Add Tag <PlusIcon />{" "}
            </span>
            <div className="tagList">{renderTags()}</div>
          </div>
        </div>
      </>
    );
  };

  const renderBlogAndForumFeed = () => {
    return (
      <>
        <div className="headlineWrapper">
          <div className="feedInfoHeader">
            <div className="feedNamePic">
              {page_details && page_details.display_picture && (
                <img src={page_details.display_picture} className="feedPic" />
              )}
              {/* <span className="feedName" onClick={() => handleFeedClick()}>{title}</span> */}
              <span className="feedName" onClick={() => handleFeedClick()}>
                {(page_details && page_details.name) || title || ""}
              </span>
            </div>
            {/* <span className="feedDivider"></span> */}
            <div className="feedChannelDate">
              {channel_type == INSTAGRAM && <InstagramIcon />}
              {channel_type == FACEBOOK && <FacebookIcon />}
              {channel_type == YOUTUBE && <YoutubePlayIcon />}
              {channel_type == TWITTER && <TwitterWBIcon />}
              <span className="newsDate"></span>
            </div>
          </div>
          <div className="rightContainer">
            <ul className="dropDownContainer">
              <ArticleTags
                article={props}
                hideTheme
                callSocialAPI
                showFavouriteTag
                isBlogAndForum
              />
            </ul>
          </div>
        </div>
        <div className="feedDetails">
          {channel_type == YOUTUBE ? <Hashtags text={title || ""} /> : null}
        </div>
        <div className="imgContainer videoContainer">
          <LazyLoad offsetVertical="1000">
            <>
              {thumbnail_link && (
                <div className="videoThumb">
                  <VideoPlayIcon />
                  <a href={permalink} target="_blank">
                    <img src={thumbnail_link} alt="NA" />
                  </a>
                </div>
              )}
            </>
          </LazyLoad>
          {showMediaAttachments()}
        </div>
        <div className="card-entities metaTagsWrap" key={id + "1"}>
          <div className="mtWrap">
            <span className="label-span hoverable">
              {channel_type == V_BLOG && "Blog :"}
              {channel_type == V_FORUM && "Forum :"}
            </span>
            <span className="link" onClick={gotoPermalink}>
              {name || "NA"}
            </span>
          </div>
          <div className="mtWrap">
            <span className="label-span">Author :</span>{" "}
            <span>{from_username || "NA"}</span>
          </div>
          <div className="mtWrap">
            <span className="label-span">Language :</span>{" "}
            <span>{LANGUAGE_CODES[lang] || "NA"}</span>
          </div>
          <div className="mtWrap">
            <span className="label-span">Publish Date :</span>{" "}
            <span>
              {formatDate(new Date(created_at), DATE_FORMATS.DDMMYYYY_dash)}
            </span>
          </div>
          <div className="mtWrap">
            <span className="label-span">Comments :</span>{" "}
            <span>{comment_count}</span>
          </div>
          <div className="mtWrap mtAddTag">
            <span
              onClick={() => setShowAddTagListModal(true)}
              className="addTag"
            >
              Add Tag <PlusIcon />{" "}
            </span>
            <div className="tagList">{renderTags()}</div>
          </div>
        </div>
      </>
    );
  };

  const renderFeeds = () => {
    if (vertical == V_SOCIAL) {
      return renderSocialFeed();
    } else if (vertical == V_BLOG || vertical == V_FORUM) {
      return renderBlogAndForumFeed();
    } else {
      return null;
    }
  };

  /* Tags Code */
  const getAddedTag = (tags) => {
    setTagsList(getUniqueValuesFromList([...tagsList, ...tags], "tag_id"));
  };

  const renderTags = () => {
    if (tagsList && tagsList.length) {
      return tagsList.map((tag) => {
        const tagName = tag.tag_name || tag.name;
        return (
          <>
            <span className="tagName">
              {tagName}
              <span
                onClick={() => removeTagFromList(tag.tag_id)}
                className="tagClose"
              >
                <TagClose />
              </span>
            </span>
          </>
        );
      });
    }
    return null;
  };

  const removeTag = (tagObject) => {
    httpDelete(
      `${unifiedEnvConfig.DELETE_TAG_FROM_FEED.replace("{id}", id)}?client_id=${
        selectedClient.id
      }`,
      tagObject
    ).catch((err) => {
      console.log(err);
      alert("Couldn't delete the tag.");
    });
  };

  const removeTagFromList = (tagId) => {
    const tagObject = tagsList
      .filter((i) => i.tag_id == tagId)
      .map((item) => {
        return {
          tag_id: item.tag_id,
          social_feed_id: id,
          channel_type: channel_type,
        };
      });
    setTagsList(tagsList.filter((i) => i.tag_id != tagId));
    removeTag(tagObject[0]);
  };
  /* Tags Code */

  return (
    <>
      {showAddTagListModal ? (
        <TagsListModal
          show={showAddTagListModal}
          onCancel={() => setShowAddTagListModal(false)}
          feedDetail={props}
          addedTag={getAddedTag}
        />
      ) : null}
      <div className="innerFeedItem socialFeedItem" body>
        {renderFeeds()}
      </div>
    </>
  );
};

export default FavouriteFeedItem;
